import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getRoleById } from "../../api/apiRoles";

export const useGetRoleById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["role", id, i18next.language],
        queryFn: () => getRoleById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        role: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
